import * as React from 'react';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { withRipple } from '../hocs/withRipple/index.js';
import swapIconPath from './swapIconPath.js';
import { Box, Details, TitleWrapper, Title, DotColor, SwapIconWrap, ImageContainer, RippleContainer, ImagePlaceholder } from './styled.js';
import { Note } from '../Note/Note.js';
import { SonntagIcon } from '../SonntagIcon/SonntagIcon.js';

const RippleEffect = withRipple(RippleContainer);
const Subscription = ({ onClick =()=>void 0 , noteData , title , img =null , subdued =false , className ="" , dotColor , highlight =false , isBeingSwapped =false  })=>{
    const image = img || /*#__PURE__*/ React.createElement(ImagePlaceholder, {
        subdued: subdued
    });
    const theme = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(Box, {
        testId: "subscription-card",
        highlight: highlight,
        className: className,
        onClick: onClick,
        defaultHoverBehavior: true
    }, /*#__PURE__*/ React.createElement(Details, null, /*#__PURE__*/ React.createElement(TitleWrapper, null, /*#__PURE__*/ React.createElement(Title, {
        subdued: subdued
    }, title), dotColor && !subdued && /*#__PURE__*/ React.createElement(DotColor, {
        dotColor: dotColor
    })), noteData && noteData.data && /*#__PURE__*/ React.createElement(Note, {
        type: noteData.type,
        data: noteData.data
    })), isBeingSwapped && /*#__PURE__*/ React.createElement(SwapIconWrap, null, /*#__PURE__*/ React.createElement(SonntagIcon, {
        iconPath: swapIconPath,
        size: 16,
        color: theme.colors.secondary
    })), /*#__PURE__*/ React.createElement(ImageContainer, {
        subdued: subdued
    }, image), /*#__PURE__*/ React.createElement(RippleEffect, null));
};

export { Subscription };
